import React from 'react';
import {Field} from 'formik';
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import moment from "moment-timezone";
import Constants from "../../../../utils/constants";
import Grid from "@mui/material/Grid2";


function RHDataField({...props}) {
    const {values, errors, handleChange, handleBlur, operateur} = props;


    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>
                    Données RH pour {operateur?.libelle}
                </Typography>
            </Grid>

            {/* TAUX CHARGES PATRONALES FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Taux Charges Patronales <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="tauxChargesPatronales">
                        {({ field, form }) => (
                            <TextField
                                {...field}
                                error={
                                    Boolean(form.errors.tauxChargesPatronales && form.touched.tauxChargesPatronales)
                                }
                                onChange={(e) => {
                                    const inputValue = e.target.value.replace(",", ".");
                                    form.setFieldValue("tauxChargesPatronales", inputValue);
                                }}
                                onBlur={handleBlur}
                                value={values.tauxChargesPatronales}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="tauxChargesPatronales"
                                label="Taux Charges Patronales (%)"
                                type="text"
                                helperText={
                                    form.errors.tauxChargesPatronales &&
                                    form.touched.tauxChargesPatronales &&
                                    String(form.errors.tauxChargesPatronales)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* TAUX HORAIRE FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Taux Horaire <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="tauxHoraire">
                        {({ field, form }) => (
                            <TextField
                                {...field}
                                error={
                                    Boolean(form.errors.tauxHoraire && form.touched.tauxHoraire)
                                }
                                onChange={(e) => {
                                    const inputValue = e.target.value.replace(",", ".");
                                    form.setFieldValue("tauxHoraire", inputValue);
                                }}
                                onBlur={handleBlur}
                                value={values.tauxHoraire}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="tauxHoraire"
                                label="Taux Horaire (€)"
                                helperText={
                                    form.errors.tauxHoraire &&
                                    form.touched.tauxHoraire &&
                                    String(form.errors.tauxHoraire)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* PANIER REPAS FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Forfait Panier Repas <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="forfaitPanierRepas">
                        {({ field, form }) => (
                            <TextField
                                {...field}
                                error={
                                    Boolean(form.errors.forfaitPanierRepas && form.touched.forfaitPanierRepas)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.forfaitPanierRepas}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="forfaitPanierRepas"
                                label="Forfait Panier Repas (€)"
                                type="number"
                                helperText={
                                    form.errors.forfaitPanierRepas &&
                                    form.touched.forfaitPanierRepas &&
                                    String(form.errors.forfaitPanierRepas)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* FORFAIT DEPLACEMENT FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Forfait Déplacement <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="forfaitDeplacement">
                        {({ field, form }) => (
                            <TextField
                                {...field}
                                error={
                                    Boolean(form.errors.forfaitDeplacement && form.touched.forfaitDeplacement)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.forfaitDeplacement}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="forfaitDeplacement"
                                label="Forfait Déplacement (€)"
                                type="number"
                                helperText={
                                    form.errors.forfaitDeplacement &&
                                    form.touched.forfaitDeplacement &&
                                    String(form.errors.forfaitDeplacement)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
            {/* CONTRAT DE TRAVAIL SECTION */}
            <Grid size={12} className={"mt-2"}>
                <Typography variant={"h6"} className={"sectionHeader"}>
                    Contrat de travail
                </Typography>
            </Grid>

            {/* TYPE CONTRAT FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Type de contrat <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field name="contratType">
                        {({ field, form }) => (
                            <FormControl fullWidth error={Boolean(form.errors.contratType && form.touched.contratType)}>
                                <InputLabel id="contrat-type-label">Type</InputLabel>
                                <Select
                                    labelId="contrat-type-label"
                                    id="contrat-type"
                                    value={values.contratType}
                                    label="Type"
                                    onChange={(e) => form.setFieldValue('contratType', e.target.value)}
                                    onBlur={handleBlur}
                                    size="small"
                                >
                                    <MenuItem value={"CDI"}>CDI</MenuItem>
                                    <MenuItem value={"CDD"}>CDD</MenuItem>
                                </Select>
                                {form.errors.contratType && form.touched.contratType && (
                                    <FormHelperText>{String(form.errors.contratType)}</FormHelperText>
                                )}
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/* DATE DEBUT CONTRAT FIELD */}
            <Grid container size={12} alignItems="center" className="mt-1 mb-1">
                <Grid size={3}>
                    <Typography>Date de début</Typography>
                </Grid>
                <Grid size={9}>
                    <Field type="text" name={"contratDateDebut"} value={values.contratDateDebut}>
                        {({ field, form }) => {
                            const startValue = values.contratDateDebut ? new Date(values.contratDateDebut) : null;
                            return (
                                <FormControl fullWidth>
                                    <DatePicker
                                        label="Date de début"
                                        value={startValue}
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const iso = moment.parseZone(newValue).startOf('day').format('YYYY-MM-DD');
                                                form.setFieldValue('contratDateDebut', iso);
                                            } else {
                                                form.setFieldValue('contratDateDebut', '');
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                variant: "outlined",
                                                margin: "normal",
                                                size: "small",
                                                error: Boolean(form.errors.contratDateDebut && form.touched.contratDateDebut),
                                                helperText: form.errors.contratDateDebut && form.touched.contratDateDebut ? form.errors.contratDateDebut : "",
                                            },
                                            field: {clearable: true},
                                        }}
                                    />
                                </FormControl>
                            );
                        }}
                    </Field>
                </Grid>
            </Grid>

            {/* DATE FIN CONTRAT FIELD */}
            {(values.contratType === 'CDD' || values.contratType === 'CDI') && (
                <Grid container size={12} alignItems="center" className="mt-1 mb-1">
                    <Grid size={3}>
                        <Typography>{values.contratType === 'CDI' ? 'Date de fin (facultative)' : 'Date de fin *'}</Typography>
                    </Grid>
                    <Grid size={9}>
                        <Field type="text" name={"contratDateFin"} value={values.contratDateFin}>
                            {({ field, form }) => {
                                const endValue = values.contratDateFin ? new Date(values.contratDateFin) : null;
                                return (
                                    <FormControl fullWidth>
                                        <DatePicker
                                            label={values.contratType === 'CDI' ? "Date de fin (facultative)" : "Date de fin *"}
                                            value={endValue}
                                            onChange={(newValue) => {
                                                if (newValue) {
                                                    const iso = moment.parseZone(newValue).startOf('day').format('YYYY-MM-DD');
                                                    form.setFieldValue('contratDateFin', iso);
                                                } else {
                                                    form.setFieldValue('contratDateFin', '');
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    variant: "outlined",
                                                    margin: "normal",
                                                    size: "small",
                                                    error: Boolean(form.errors.contratDateFin && form.touched.contratDateFin),
                                                    helperText: form.errors.contratDateFin && form.touched.contratDateFin ? form.errors.contratDateFin : "",
                                                },
                                                field: {clearable: true},
                                            }}
                                        />
                                    </FormControl>
                                );
                            }}
                        </Field>
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}

export default RHDataField;
